module.exports = __webpack_public_path__ + "132ed7e9c03cd711943b7d7f1ab0730c.svg";